import type { PageKey } from "@owners/shared-types";

/** URL for each page. Keys match @owners/shared-types PAGES. */
export const PATHS: Record<PageKey, string> = {
  todays_update: "/",
  flash_reports: "/flash",
  awaiting_approval: "/approvals",
  missing_data: "/missing-data",
  asset_management: "/asset-management",
  reo_documents: "/asset-management/reo",
  compliance: "/asset-management/compliance",
  debt_compliance: "/asset-management/debt",
  budget_reforecast: "/asset-management/budget",
  financial_reports: "/financial-reports",
  my_reports: "/my-reports",
  receiver_reports: "/receiver-reports",
  receivership: "/receivership",
  trends: "/trends",
  team_members: "/team",
  leadership: "/leadership",
  guest_reviews: "/reviews",
  request_records: "/records",
  settings: "/settings",
  dataroom: "/dataroom",
  admin_panel: "/admin",
};

/** Which build phase delivers each page (PROPOSAL §9) — shown on placeholders. */
export const PHASE: Partial<Record<PageKey, number>> = {
  todays_update: 1, flash_reports: 1, financial_reports: 1, dataroom: 1, missing_data: 1,
  reo_documents: 1, compliance: 1,
  debt_compliance: 2, budget_reforecast: 2, my_reports: 2, awaiting_approval: 2, trends: 2,
  team_members: 2, leadership: 2, guest_reviews: 2, request_records: 2,
  receiver_reports: 3, receivership: 3,
};
